import { AbstractBlock } from '../AbstractBlock';

//<label text="A label" web-class="myLabelStyle"></label>
export class Label extends AbstractBlock {
  private value = '';
  private webclass = '';

  constructor() {
    super('label', '');
    this.webclass = 'label_flyout';
  }

  toXml(): HTMLElement {
    const el = document.createElement('label') as HTMLLabelElement;
    el.setAttribute('text', this.value);
    el.setAttribute('web-class', this.webclass);
    return el;
  }
}
